var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 13C6.5 8.85786 9.85786 5.5 14 5.5C18.1421 5.5 21.5 8.85786 21.5 13C21.5 17.1421 18.1421 20.5 14 20.5C9.85786 20.5 6.5 17.1421 6.5 13ZM14 7.5C10.9624 7.5 8.5 9.96243 8.5 13C8.5 16.0376 10.9624 18.5 14 18.5C17.0376 18.5 19.5 16.0376 19.5 13C19.5 9.96243 17.0376 7.5 14 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 18C17.0523 18 17.5 18.4477 17.5 19V23.5C17.5 25.433 15.933 27 14 27C12.067 27 10.5 25.433 10.5 23.5V19H12.5V23.5C12.5 24.3284 13.1716 25 14 25C14.8284 25 15.5 24.3284 15.5 23.5V19C15.5 18.4477 15.9477 18 16.5 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.5C14.5523 3.5 15 3.05228 15 2.5C15 1.94772 14.5523 1.5 14 1.5C13.4477 1.5 13 1.94772 13 2.5C13 3.05228 13.4477 3.5 14 3.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.5C12.5 1.67157 13.1716 1 14 1C14.8284 1 15.5 1.67157 15.5 2.5C15.5 3.32843 14.8284 4 14 4C13.1716 4 12.5 3.32843 12.5 2.5ZM14 2C13.7239 2 13.5 2.22386 13.5 2.5C13.5 2.77614 13.7239 3 14 3C14.2761 3 14.5 2.77614 14.5 2.5C14.5 2.22386 14.2761 2 14 2Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8642 6.13597C21.2547 6.52649 21.8879 6.52649 22.2784 6.13597C22.6689 5.74544 22.6689 5.11228 22.2784 4.72176C21.8879 4.33123 21.2547 4.33123 20.8642 4.72176C20.4737 5.11228 20.4737 5.74544 20.8642 6.13597Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5106 4.36828C21.0964 3.78249 22.0462 3.78249 22.6319 4.36828C23.2177 4.95406 23.2177 5.90381 22.6319 6.4896C22.0462 7.07538 21.0964 7.07538 20.5106 6.4896C19.9248 5.90381 19.9248 4.95406 20.5106 4.36828ZM21.9248 5.07538C21.7296 4.88012 21.413 4.88012 21.2177 5.07538C21.0225 5.27065 21.0225 5.58723 21.2177 5.78249C21.413 5.97775 21.7296 5.97775 21.9248 5.78249C22.1201 5.58723 22.1201 5.27065 21.9248 5.07538Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 13C23.5 13.5523 23.9477 14 24.5 14C25.0523 14 25.5 13.5523 25.5 13C25.5 12.4477 25.0523 12 24.5 12C23.9477 12 23.5 12.4477 23.5 13Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 11.5C25.3284 11.5 26 12.1716 26 13C26 13.8284 25.3284 14.5 24.5 14.5C23.6716 14.5 23 13.8284 23 13C23 12.1716 23.6716 11.5 24.5 11.5ZM25 13C25 12.7239 24.7761 12.5 24.5 12.5C24.2239 12.5 24 12.7239 24 13C24 13.2761 24.2239 13.5 24.5 13.5C24.7761 13.5 25 13.2761 25 13Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.864 19.8637C20.4735 20.2542 20.4735 20.8874 20.864 21.2779C21.2546 21.6684 21.8877 21.6684 22.2782 21.2779C22.6688 20.8874 22.6688 20.2542 22.2782 19.8637C21.8877 19.4732 21.2546 19.4732 20.864 19.8637Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6317 19.5101C23.2175 20.0959 23.2175 21.0457 22.6317 21.6315C22.0459 22.2172 21.0962 22.2172 20.5104 21.6315C19.9246 21.0457 19.9246 20.0959 20.5104 19.5101C21.0962 18.9244 22.0459 18.9244 22.6317 19.5101ZM21.9246 20.9244C22.1199 20.7291 22.1199 20.4125 21.9246 20.2172C21.7294 20.022 21.4128 20.022 21.2175 20.2172C21.0222 20.4125 21.0222 20.7291 21.2175 20.9244C21.4128 21.1196 21.7294 21.1196 21.9246 20.9244Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13582 19.864C6.74529 19.4735 6.11213 19.4735 5.7216 19.864C5.33108 20.2546 5.33108 20.8877 5.7216 21.2782C6.11213 21.6688 6.74529 21.6688 7.13582 21.2782C7.52634 20.8877 7.52634 20.2546 7.13582 19.864Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48937 21.6317C6.90358 22.2175 5.95384 22.2175 5.36805 21.6317C4.78226 21.0459 4.78226 20.0962 5.36805 19.5104C5.95384 18.9246 6.90358 18.9246 7.48937 19.5104C8.07516 20.0962 8.07516 21.0459 7.48937 21.6317ZM6.07516 20.9246C6.27042 21.1199 6.587 21.1199 6.78226 20.9246C6.97753 20.7294 6.97753 20.4128 6.78226 20.2175C6.587 20.0222 6.27042 20.0222 6.07516 20.2175C5.8799 20.4128 5.8799 20.7294 6.07516 20.9246Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 13C4.5 12.4477 4.05228 12 3.5 12C2.94772 12 2.5 12.4477 2.5 13C2.5 13.5523 2.94772 14 3.5 14C4.05228 14 4.5 13.5523 4.5 13Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14.5C2.67157 14.5 2 13.8284 2 13C2 12.1716 2.67157 11.5 3.5 11.5C4.32843 11.5 5 12.1716 5 13C5 13.8284 4.32843 14.5 3.5 14.5ZM3 13C3 13.2761 3.22386 13.5 3.5 13.5C3.77614 13.5 4 13.2761 4 13C4 12.7239 3.77614 12.5 3.5 12.5C3.22386 12.5 3 12.7239 3 13Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13597 6.13631C7.52649 5.74578 7.52649 5.11262 7.13597 4.72209C6.74544 4.33157 6.11228 4.33157 5.72176 4.72209C5.33123 5.11262 5.33123 5.74578 5.72176 6.13631C6.11228 6.52683 6.74544 6.52683 7.13597 6.13631Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36828 6.48986C4.78249 5.90407 4.78249 4.95433 5.36828 4.36854C5.95406 3.78275 6.90381 3.78275 7.4896 4.36854C8.07538 4.95433 8.07538 5.90407 7.4896 6.48986C6.90381 7.07565 5.95406 7.07565 5.36828 6.48986ZM6.07538 5.07565C5.88012 5.27091 5.88012 5.58749 6.07538 5.78275C6.27065 5.97801 6.58723 5.97801 6.78249 5.78275C6.97775 5.58749 6.97775 5.27091 6.78249 5.07565C6.58723 4.88038 6.27065 4.88038 6.07538 5.07565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHint);
export default __webpack_public_path__ + "static/media/ic_hint.6f2b5e7d536999142b0b574276ab59eb.svg";
export { ForwardRef as ReactComponent };